import { useEffect, useState } from "react";
//#region src/hooks/useSessionStorage.ts
function getItem(key, defaultValue) {
	try {
		if (!key) return defaultValue;
		const item = window.sessionStorage.getItem(key);
		return item ? JSON.parse(item) : defaultValue;
	} catch (error) {
		console.warn(`useSessionStorage.getItem(${key}) error getting item`, error, `sessionStorage value: ${window.sessionStorage.getItem(key)}`, `removing bad item from sessionStorage`);
		window.sessionStorage.removeItem(key);
		return defaultValue;
	}
}
function setItem(key, value) {
	try {
		if (typeof value === "undefined") window.sessionStorage.removeItem(key);
		else window.sessionStorage.setItem(key, JSON.stringify(value));
		window.dispatchEvent(new CustomEvent(`sessionStorage_${key}`, { detail: { key } }));
	} catch (error) {
		console.warn(`useSessionStorage.setItem(${key}) error setting item`, error, "value: ", value);
	}
}
/**
* Store values in session storage the same as the useState() hook.
*
* If no "key" is passed then no sessionStorage will take place.
*/
function useSessionStorage(key, defaultValue) {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const sessionStorageValue = getItem(key);
			if (!sessionStorageValue) {
				let _defaultValue = defaultValue;
				if (defaultValue instanceof Function) _defaultValue = defaultValue();
				return _defaultValue;
			}
			return sessionStorageValue;
		} catch (error) {
			console.error("useSessionStorage() initialValue state error", error);
			return;
		}
	});
	const setValue = (value) => {
		try {
			const valueToStore = value instanceof Function ? value(storedValue) : value;
			setStoredValue(valueToStore);
			if (key) {
				setItem(key, valueToStore);
				window.dispatchEvent(new CustomEvent(`sessionStorage_${key}`, { detail: { key } }));
			}
		} catch (error) {
			console.error(error);
		}
	};
	useEffect(() => {
		const handler = (event) => {
			if ((event.key || event.detail?.key) === key) setStoredValue(getItem(key));
		};
		addEventListener(`sessionStorage_${key}`, handler);
		return () => removeEventListener(`sessionStorage_${key}`, handler);
	}, [key]);
	return [storedValue, setValue];
}
useSessionStorage.setItem = setItem;
useSessionStorage.getItem = getItem;
//#endregion
export { useSessionStorage };

//# sourceMappingURL=useSessionStorage.js.map